/* global jQuery */
(function ($, window, App, ns) {

    var CookieManage;

    /**
     * Encode string.
     *
     * @param {string} string
     * @returns {string}
     */
    function encode(string) {
        return encodeURIComponent(string);
    }

    /**
     * Decode string.
     *
     * @param {string} string
     * @returns {string}
     */
    function decode(string) {
        return decodeURIComponent(string);
    }

    /**
     * Trim whitespaces from the left side of the string.
     *
     * @param {string} string
     * @returns {string}
     */
    function leftTrim(string) {
        while (string.charAt(0) === ' ') {
            string = string.substring(1);
        }

        return string;
    }

    CookieManage = {
        /**
         * Set a cookie.
         *
         * @param {String} key Cookie name.
         * @param {String} value Cookie value.
         * @param {Number} days If given cookie will expire in n days. If no value is given it creates a session cookie.
         */
        set: function (key, value, days) {
            var date, expires = '';

            if (typeof days !== 'undefined') {
                date = new Date();
                date.setDate(date.getDate() + days);
                expires = '; expires=' + date.toUTCString();
            }

            value = encode(value) + expires + '; path=/';

            window.document.cookie = encode(key) + '=' + value;
        },

        /**
         * Get a cookie.
         *
         * @param {String} key Cookie name.
         *
         * @returns {string} Returns the cookie value or an empty string if it wasn't find.
         */
        get: function get(key) {
            var cookies = document.cookie.split(';'),
                i, length, cookie, name, parts;

            for (i = 0, length = cookies.length; i < length; i++) {
                cookie = leftTrim(cookies[i]);
                parts = cookie.split('=');
                name = parts.shift();
                cookie = parts.join('=');

                if (key === name) {
                    return decode(cookie);
                }
            }

            return '';
        },

        /**
         * Checks if a cookie is defined.
         *
         * @param {String} key Cookie name.
         * @returns {boolean}
         */
        isset: function (key) {
            return (window.document.cookie.indexOf(key + '=') !== -1);
        },

        /**
         * Remove a cookie.
         *
         * @param {String} key
         */
        remove: function removeCookie(key) {
            this.set(key, '', -1);
        }
    };

    // Reveal module in Namespace and App.
    App.Cookie = CookieManage;

    ns.utilities = ns.utilities || {};
    ns.utilities.CookieManage = CookieManage;

}(jQuery, window, window.App || {}, window.Namespace || {}));
